import Close from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import type Snackbar from '@mui/material/Snackbar';
import { styled } from '@mui/system';
import { IconButton } from '@src/common/components/IconButton';
import { Stack } from '@src/common/components/Stack';
import type { ToastLevel } from '@src/common/components/ToastLevel';
import { theme } from '@src/common/styles/Theme';
import type { CustomContentProps } from 'notistack';
import { closeSnackbar, SnackbarContent } from 'notistack';
import type { ComponentProps } from 'react';
import React from 'react';

type Props = {
  severity: ToastLevel;
  title?: string;
  message: string | React.ReactNode;
} & ComponentProps<typeof Snackbar> &
  CustomContentProps;

export const Toast = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      id,
      title,
      message,
      severity,
      persist: _,
      autoHideDuration: __,
      anchorOrigin: ___,
      hideIconVariant: ____,
      iconVariant: _____,
      ...other
    },
    ref,
  ) => {
    return (
      <SnackbarContent ref={ref} role="alert" {...other}>
        <Alert
          id={`${id}`}
          severity={severity}
          style={{ placeItems: title ? 'start' : 'center' }}
        >
          <Stack direction="column">
            <Bold>{title}</Bold>
            <Stack direction="row" alignItems="center" gap={theme.spacing['3']}>
              {message}
              <IconButton onClick={() => closeSnackbar(id)}>
                <Close />
              </IconButton>
            </Stack>
          </Stack>
        </Alert>
      </SnackbarContent>
    );
  },
);

const Bold = styled('div')`
  font-weight: 500;
`;
